// extracted by mini-css-extract-plugin
export var imageContainer = "Image-module--imageContainer--1Bnta";
export var videoContainer = "Image-module--videoContainer--1Fwj8";
export var picture = "Image-module--picture--3sXs9";
export var muxPlayer = "Image-module--muxPlayer--1NxNb";
export var captionTop = "Image-module--captionTop--3gN3y";